import { produce } from "immer";
import {
  GET_TRANSFER_PACK,
  GET_TRANSFER_PACK_SUCCESS,
  GET_TRANSFER_PACK_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingPack: false,
  pack: null,
};

const TransferPackReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_TRANSFER_PACK:
        draft.isFetchingPack = true;
        break;
      case GET_TRANSFER_PACK_SUCCESS:
        draft.isFetchingPack = false;
        // apiResponse envelope: { status, data: <pack>, message }
        draft.pack = action.payload?.data || action.payload;
        break;
      case GET_TRANSFER_PACK_FAILURE:
        draft.isFetchingPack = false;
        draft.pack = null;
        break;
      default:
        return state;
    }
  });

export default TransferPackReducer;
